// src/Services/ofertaUtils.ts
import type { OfertaResponse } from '../store/MSCommerce/Ofertas/types';

export interface OfertaAplicada {
  oferta: OfertaResponse;
  precioFinal: number;
  precioOriginal: number;
  badge: string; // texto del badge: "-20%", "2x1", "-$5"
}

export function getOfertaParaProducto(
  productoId: string,
  categoriaId: string | null,
  ofertas: OfertaResponse[]
): OfertaResponse | null {          // ← corregido
  const oferta = ofertas.find(o =>
    o.detalles.some(d =>
      (d.tipoReferencia === 'PRODUCTO' && d.referenciaId === productoId) ||
      (d.tipoReferencia === 'CATEGORIA' && d.referenciaId === categoriaId)
    )
  );
  return oferta ?? null;
}

export function calcularPrecioFinal(
  precioOriginal: number,
  oferta: OfertaResponse
): { precioFinal: number; badge: string } {
  switch (oferta.tipo) {
    case 'PORCENTAJE':
      return {
        precioFinal: precioOriginal * (1 - oferta.valor / 100),
        badge: `-${oferta.valor}%`,
      };
    case 'MONTO_FIJO':
      return {
        precioFinal: Math.max(0, precioOriginal - oferta.valor),
        badge: `-$${oferta.valor}`,
      };
    case '2x1':
      return {
        precioFinal: precioOriginal,
        badge: '2x1',
      };
    default:
      return { precioFinal: precioOriginal, badge: '' };
  }
}